const state = {
  countries: [
    { abbr: 'BRA', name: 'Brasil' }
  ],
  states: [
    { country: 'BRA', abbr: 'AC', name: 'Acre' },
    { country: 'BRA', abbr: 'AL', name: 'Alagoas' },
    { country: 'BRA', abbr: 'AP', name: 'Amapá' },
    { country: 'BRA', abbr: 'AM', name: 'Amazonas' },
    { country: 'BRA', abbr: 'BA', name: 'Bahia' },
    { country: 'BRA', abbr: 'CE', name: 'Ceará' },
    { country: 'BRA', abbr: 'DF', name: 'Distrito Federal' },
    { country: 'BRA', abbr: 'ES', name: 'Espírito Santo' },
    { country: 'BRA', abbr: 'GO', name: 'Goiás' },
    { country: 'BRA', abbr: 'MA', name: 'Maranhão' },
    { country: 'BRA', abbr: 'MT', name: 'Mato Grosso' },
    { country: 'BRA', abbr: 'MS', name: 'Mato Grosso do Sul' },
    { country: 'BRA', abbr: 'MG', name: 'Minas Gerais' },
    { country: 'BRA', abbr: 'PA', name: 'Pará' },
    { country: 'BRA', abbr: 'PB', name: 'Paraíba' },
    { country: 'BRA', abbr: 'PR', name: 'Paraná' },
    { country: 'BRA', abbr: 'PE', name: 'Pernambuco' },
    { country: 'BRA', abbr: 'PI', name: 'Piauí' },
    { country: 'BRA', abbr: 'RJ', name: 'Rio de Janeiro' },
    { country: 'BRA', abbr: 'RN', name: 'Rio Grande do Norte' },
    { country: 'BRA', abbr: 'RS', name: 'Rio Grande do Sul' },
    { country: 'BRA', abbr: 'RO', name: 'Rondônia' },
    { country: 'BRA', abbr: 'RR', name: 'Roraima' },
    { country: 'BRA', abbr: 'SC', name: 'Santa Catarina' },
    { country: 'BRA', abbr: 'SP', name: 'São Paulo' },
    { country: 'BRA', abbr: 'SE', name: 'Sergipe' },
    { country: 'BRA', abbr: 'TO', name: 'Tocantins' }
  ],
  schooling: [
    { _id: '1', name: 'Doutorado' },
    { _id: '2', name: 'Educação infantil' },
    { _id: '3', name: 'Ensino Fundamental' },
    { _id: '4', name: 'Ensino Médio' },
    { _id: '5', name: 'Mestrado' },
    { _id: '6', name: 'Pós-graduação' },
    { _id: '7', name: 'Superior' }
  ],
  schoolingStatuses: [
    { _id: '1', name: 'Completo' },
    { _id: '2', name: 'Cursando' },
    { _id: '3', name: 'Incompleto' }
  ],
  roles: [
    { _id: '1', name: 'Administrador' },
    { _id: '2', name: 'Arquivista' },
    { _id: '3', name: 'Auxiliar Administrativo' },
    { _id: '4', name: 'Auxiliar de Escritório' },
    { _id: '5', name: 'Carregador' },
    { _id: '6', name: 'Conferente de Carga' },
    { _id: '7', name: 'DP/RH' },
    { _id: '8', name: 'Diretor Executivo' },
    { _id: '9', name: 'Encarregado' },
    { _id: '10', name: 'Líder' },
    { _id: '11', name: 'Supervisor' },
    { _id: '12', name: 'Diretor Presidente' },
    { _id: '13', name: 'Auxiliar de Encarregado' },
    { _id: '14', name: 'Assistente administrativo' },
    { _id: '15', name: 'Coordenadora administrativa' }
  ],
  manpowers: [
    { _id: '1', name: 'Operacional' },
    { _id: '2', name: 'Gestão' }
  ],
  hiringStatuses: [
    { _id: '1', name: 'Contratado' },
    { _id: '2', name: 'Demitido' },
    { _id: '3', name: 'Experiência' },
    { _id: '4', name: 'Férias' },
    { _id: '5', name: 'Suspensão' },
    { _id: '6', name: 'Afastado' }
  ],
  experienceDays: [
    { _id: '1', value: '45' },
    { _id: '2', value: '90' }
  ],
  warningTypes: [
    { _id: '1', name: 'Suspensão' },
    { _id: '2', name: 'Advertência' },
    { _id: '3', name: 'Atestado' }
  ],
  pointActivities: [
    { _id: '1', name: 'Iniciar expediente' },
    { _id: '2', name: 'Encerrar expediente' },
    { _id: '3', name: 'Iniciar horário de almoço' },
    { _id: '4', name: 'Encerrar horário de almoço' },
    { _id: '5', name: 'Iniciar hora extra' },
    { _id: '6', name: 'Encerrar hora extra' },
    { _id: '7', name: 'Iniciar realocação' },
    { _id: '8', name: 'Encerrar realocação' }
  ],
  serviceCategories: [
    { _id: 1, name: 'Eletrônicos' },
    { _id: 2, name: 'FLV Caixa' },
    { _id: 3, name: 'FLV Sacos' },
    { _id: 4, name: 'Frigorífico' },
    { _id: 5, name: 'Mercearia' },
    { _id: 6, name: 'Perecíveis' },
    { _id: 7, name: 'Exceções Manaus' },
    { _id: 8, name: 'Diversos' },
    { _id: 9, name: 'Móveis' },
    { _id: 10, name: 'Hortifruti' },
  ],
  services: [
    { _id: 1, categoryId: 1, name: '608-3/4' },
    { _id: 2, categoryId: 1, name: 'Kombi/Van' },
    { _id: 3, categoryId: 1, name: 'Carreta' },
    { _id: 4, categoryId: 1, name: 'Bitrem' },
    { _id: 5, categoryId: 1, name: 'Truck/Toco' },
    { _id: 6, categoryId: 1, name: 'Fiorino' },
    { _id: 7, categoryId: 1, name: 'Carro de Passeio' },
    { _id: 8, categoryId: 2, name: 'Até 5kg' },
    { _id: 9, categoryId: 2, name: 'De 5,01kg a 10kg' },
    { _id: 10, categoryId: 2, name: '> 10kg' },
    { _id: 11, categoryId: 3, name: 'Importação ou transferência' },
    { _id: 12, categoryId: 3, name: 'Etiquetagem' },
    { _id: 13, categoryId: 3, name: 'Até 25kg' },
    { _id: 14, categoryId: 3, name: '> 25kg' },
    { _id: 15, categoryId: 3, name: 'Filme Strech' },
    { _id: 16, categoryId: 3, name: 'Melancia a Granel (Truck ou Carreta)' },
    { _id: 17, categoryId: 3, name: 'Descarga de leite (Palete)' },
    { _id: 18, categoryId: 3, name: 'Caixa de flores' },
    { _id: 19, categoryId: 3, name: 'Palete' },
    { _id: 20, categoryId: 4, name: 'Remontagem de palete' },
    { _id: 21, categoryId: 4, name: 'Tonelada' },
    { _id: 22, categoryId: 4, name: 'Volume' },
    { _id: 23, categoryId: 4, name: 'Devolução por volume' },
    { _id: 24, categoryId: 4, name: 'Volume batido' },
    { _id: 25, categoryId: 4, name: 'Devolução tonelada' },
    { _id: 26, categoryId: 4, name: 'Strechamento de palete' },
    { _id: 27, categoryId: 4, name: 'Filme por palete' },
    { _id: 28, categoryId: 4, name: 'Paletização com filme (Repasse)' },
    { _id: 29, categoryId: 5, name: 'Paletização com filme (Repasse)' },
    { _id: 30, categoryId: 5, name: 'Volume batido (carga seca)' },
    { _id: 31, categoryId: 5, name: '31 a 100 volumes' },
    { _id: 32, categoryId: 5, name: 'Pneu' },
    { _id: 33, categoryId: 5, name: 'Freet Foob' },
    { _id: 34, categoryId: 5, name: 'Container' },
    { _id: 35, categoryId: 5, name: 'Truck do Inbound' },
    { _id: 36, categoryId: 5, name: 'Lonar e deslonar' },
    { _id: 37, categoryId: 5, name: 'Inbound' },
    { _id: 38, categoryId: 5, name: 'Filme por palete' },
    { _id: 39, categoryId: 5, name: 'Até 30 volumes' },
    { _id: 40, categoryId: 5, name: 'Devolução palete' },
    { _id: 41, categoryId: 5, name: 'Paletes Puxado' },
    { _id: 42, categoryId: 5, name: 'Remontagem de palete' },
    { _id: 43, categoryId: 5, name: 'Estrechamento de palete' },
    { _id: 44, categoryId: 5, name: 'Volume' },
    { _id: 45, categoryId: 5, name: 'Acima de 100' },
    { _id: 46, categoryId: 5, name: 'Palete' },
    { _id: 47, categoryId: 5, name: 'Devolução por volume' },
    { _id: 48, categoryId: 5, name: 'Bobina/strech' },
    { _id: 49, categoryId: 4, name: 'Pesada Paletizada Não Misturada' },
    { _id: 50, categoryId: 4, name: 'Pesada Paletizada Fora do Padrão' },
    { _id: 51, categoryId: 4, name: 'Pesada Paletizada Misturada' },
    { _id: 52, categoryId: 4, name: 'Pesada Batida Mistudada' },
    { _id: 53, categoryId: 4, name: 'Pesada Batida Não Misturada' },
    { _id: 54, categoryId: 4, name: 'Volumosa Paletizada Não Misturada' },
    { _id: 55, categoryId: 4, name: 'Volumosa Paletizada Misturada' },
    { _id: 56, categoryId: 4, name: 'Volumosa Batida Misturada' },
    { _id: 57, categoryId: 4, name: 'Pesada Paletizada Não Misturada (N/A)' },
    { _id: 58, categoryId: 4, name: 'Pesada Paletizada Fora do Padrão (N/A)' },
    { _id: 59, categoryId: 4, name: 'Pesada Paletizada Misturada (N/A)' },
    { _id: 60, categoryId: 4, name: 'Pesada Batida Mistudada (N/A)' },
    { _id: 61, categoryId: 4, name: 'Pesada Batida Não Misturada (N/A)' },
    { _id: 62, categoryId: 4, name: 'Volumosa Paletizada Não Misturada (N/A)' },
    { _id: 63, categoryId: 4, name: 'Volumosa Paletizada Misturada (N/A)' },
    { _id: 64, categoryId: 4, name: 'Volumosa Batida Misturada (N/A)' },
    { _id: 65, categoryId: 5, name: 'Pesada Paletizada Não Misturada' },
    { _id: 66, categoryId: 5, name: 'Pesada Paletizada Fora do Padrão' },
    { _id: 67, categoryId: 5, name: 'Pesada Paletizada Misturada' },
    { _id: 68, categoryId: 5, name: 'Pesada Batida Mistudada' },
    { _id: 69, categoryId: 5, name: 'Pesada Batida Não Misturada' },
    { _id: 70, categoryId: 5, name: 'Volumosa Paletizada Não Misturada' },
    { _id: 71, categoryId: 5, name: 'Volumosa Paletizada Misturada' },
    { _id: 72, categoryId: 5, name: 'Volumosa Batida Misturada' },
    { _id: 73, categoryId: 5, name: 'Pesada Paletizada Não Misturada (N/A)' },
    { _id: 74, categoryId: 5, name: 'Pesada Paletizada Fora do Padrão (N/A)' },
    { _id: 75, categoryId: 5, name: 'Pesada Paletizada Misturada (N/A)' },
    { _id: 76, categoryId: 5, name: 'Pesada Batida Mistudada (N/A)' },
    { _id: 77, categoryId: 5, name: 'Pesada Batida Não Misturada (N/A)' },
    { _id: 78, categoryId: 5, name: 'Volumosa Paletizada Não Misturada (N/A)' },
    { _id: 79, categoryId: 5, name: 'Volumosa Paletizada Misturada (N/A)' },
    { _id: 80, categoryId: 5, name: 'Volumosa Batida Misturada (N/A)' },
    { _id: 81, categoryId: 5, name: 'Carreta Eletro' },
    { _id: 82, categoryId: 5, name: 'Bitrem Eletro' },
    { _id: 83, categoryId: 5, name: 'Caixa ou Fardo Até 10kg' },
    { _id: 84, categoryId: 5, name: 'Caixa ou Fardo de 11kg a 20kg' },
    { _id: 85, categoryId: 5, name: 'Caixa ou Fardo de 21kg em diante' },
    { _id: 86, categoryId: 5, name: 'Deslonamento de Truck' },
    { _id: 87, categoryId: 5, name: 'Separação de Movimentação de Sabores ou Fragrâncias' },
    { _id: 88, categoryId: 5, name: 'Por pallet (fora de agendamento)' },
    { _id: 89, categoryId: 5, name: 'Por pallet (agendamento)' },
    { _id: 90, categoryId: 5, name: 'Por volume (fora de agendamento)' },
    { _id: 91, categoryId: 5, name: 'Por volume (agendamento)' },
    { _id: 92, categoryId: 5, name: 'Filmar pallet/repaletizar (fora de agendamento)' },
    { _id: 93, categoryId: 5, name: 'Filmar pallet/repaletizar (agendamento)' },
    { _id: 94, categoryId: 5, name: 'Devolução pallet (fora de agendamento)' },
    { _id: 95, categoryId: 5, name: 'Devolução pallet (agendamento)' },
    { _id: 96, categoryId: 5, name: 'Devolução volume (fora de agendamento)' },
    { _id: 97, categoryId: 5, name: 'Devolução volume (agendamento)' },
    { _id: 98, categoryId: 6, name: 'Por tonelada (fora de agendamento)' },
    { _id: 99, categoryId: 6, name: 'Por tonelada (agendamento)' },
    { _id: 100, categoryId: 6, name: 'Por volume (fora de agendamento)' },
    { _id: 101, categoryId: 6, name: 'Por volume (agendamento)' },
    { _id: 102, categoryId: 6, name: 'Filmar pallet/repaletizar (fora de agendamento)' },
    { _id: 103, categoryId: 6, name: 'Filmar pallet/repaletizar (agendamento)' },
    { _id: 104, categoryId: 6, name: 'Devolução volume (fora de agendamento)' },
    { _id: 105, categoryId: 6, name: 'Devolução volume (agendamento)' },
    { _id: 106, categoryId: 6, name: 'Devolução tonelada (fora de agendamento)' },
    { _id: 107, categoryId: 6, name: 'Devolução tonelada (agendamento)' },
    { _id: 108, categoryId: 7, name: 'Eletro (fora de agendamento)' },
    { _id: 109, categoryId: 7, name: 'Eletro (agendamento)' },
    { _id: 110, categoryId: 7, name: 'Container (fora de agendamento)' },
    { _id: 111, categoryId: 7, name: 'Container (agendamento)' },
    { _id: 112, categoryId: 7, name: 'Pneu (fora de agendamento)' },
    { _id: 113, categoryId: 7, name: 'Pneu (agendamento)' },
    { _id: 114, categoryId: 7, name: 'Bobina stretch (fora de agendamento)' },
    { _id: 115, categoryId: 7, name: 'Bobina stretch (agendamento)' },
    { _id: 116, categoryId: 7, name: 'Lonar e deslonar veículo (fora de agendamento)' },
    { _id: 117, categoryId: 7, name: 'Lonar e deslonar veículo (agendamento)' },
    { _id: 118, categoryId: 2, name: 'Até 5kg (fora de agendamento)' },
    { _id: 119, categoryId: 2, name: 'Até 5kg (agendamento)' },
    { _id: 120, categoryId: 2, name: '5,01 a 10kg (fora de agendamento)' },
    { _id: 121, categoryId: 2, name: '5,01 a 10kg (agendamento)' },
    { _id: 122, categoryId: 2, name: '> 10kg (fora de agendamento)' },
    { _id: 123, categoryId: 2, name: '> 10kg (agendamento)' },
    { _id: 124, categoryId: 3, name: 'Até 25kg (fora de agendamento)' },
    { _id: 125, categoryId: 3, name: 'Até 25kg (agendamento)' },
    { _id: 126, categoryId: 3, name: '> 25kg (fora de agendamento)' },
    { _id: 127, categoryId: 3, name: '> 25kg (agendamento)' },
    { _id: 128, categoryId: 3, name: 'Pallet (fora de agendamento)' },
    { _id: 129, categoryId: 3, name: 'Pallet (agendamento)' },
    { _id: 130, categoryId: 3, name: 'Filme stretch (fora de agendamento)' },
    { _id: 131, categoryId: 3, name: 'Filme stretch (agendamento)' },
    { _id: 132, categoryId: 7, name: 'Etiquetagem (fora de agendamento)' },
    { _id: 133, categoryId: 7, name: 'Etiquetagem (agendamento)' },
    { _id: 134, categoryId: 7, name: 'Caixa de flores (fora de agendamento)' },
    { _id: 135, categoryId: 7, name: 'Caixa de flores (agendamento)' },
    { _id: 136, categoryId: 7, name: 'Melancia a granel truck ou carreta tonelada (fora de agendamento)' },
    { _id: 137, categoryId: 7, name: 'Melancia a granel truck ou carreta tonelada (agendamento)' },
    { _id: 138, categoryId: 7, name: 'Importação e transferência (fora de agendamento)' },
    { _id: 139, categoryId: 7, name: 'Importação e transferência (agendamento)' },
    { _id: 140, categoryId: 7, name: 'Descarga de leite pallet (fora de agendamento)' },
    { _id: 141, categoryId: 7, name: 'Descarga de leite pallet (agendamento)' },
    { _id: 142, categoryId: 7, name: 'FLV - Lonar e deslonar veículo (fora de agendamento)' },
    { _id: 143, categoryId: 7, name: 'FLV - Lonar e deslonar veículo (agendamento)' },
    { _id: 144, categoryId: 5, name: 'Container de 20 e 40 pés' },
    { _id: 145, categoryId: 5, name: 'Truck/Caminhão/Toco' },
    { _id: 146, categoryId: 6, name: 'Container de 20 e 40 pés' },
    { _id: 147, categoryId: 6, name: 'Truck/Caminhão/Toco' },
    { _id: 148, categoryId: 1, name: 'Container de 20 e 40 pés' },
    { _id: 149, categoryId: 1, name: 'Truck/Caminhão/Toco' },
    { _id: 150, categoryId: 1, name: 'Carreta Pneu (bobinas stretch inclusas)' },
    { _id: 151, categoryId: 1, name: 'Carro de Eletro (bobinas stretch inclusas)' },
    { _id: 152, categoryId: 4, name: 'Lonar e deslonar' },
    { _id: 153, categoryId: 8, name: 'Volume' },
    { _id: 154, categoryId: 2, name: 'Container de 20 e 40 pés' },
    { _id: 155, categoryId: 2, name: 'Container' },
    { _id: 156, categoryId: 2, name: 'VAN' },
    { _id: 157, categoryId: 2, name: 'BAÚ' },
    { _id: 158, categoryId: 2, name: 'Log-In Transportes e Logística' },
    { _id: 159, categoryId: 2, name: 'Aliança Navegação' },
    { _id: 160, categoryId: 3, name: 'Container de 20 e 40 pés' },
    { _id: 161, categoryId: 3, name: 'Container' },
    { _id: 162, categoryId: 3, name: 'VAN' },
    { _id: 163, categoryId: 3, name: 'BAÚ' },
    { _id: 164, categoryId: 3, name: 'Log-In Transportes e Logística' },
    { _id: 165, categoryId: 3, name: 'Aliança Navegação' },
    { _id: 166, categoryId: 5, name: 'Container de 20 e 40 pés' },
    { _id: 167, categoryId: 5, name: 'Container' },
    { _id: 168, categoryId: 5, name: 'VAN' },
    { _id: 169, categoryId: 5, name: 'BAÚ' },
    { _id: 170, categoryId: 5, name: 'Log-In Transportes e Logística' },
    { _id: 171, categoryId: 5, name: 'Aliança Navegação' },
    { _id: 172, categoryId: 6, name: 'Container de 20 e 40 pés' },
    { _id: 173, categoryId: 6, name: 'Container' },
    { _id: 174, categoryId: 6, name: 'VAN' },
    { _id: 175, categoryId: 6, name: 'BAÚ' },
    { _id: 176, categoryId: 6, name: 'Log-In Transportes e Logística' },
    { _id: 177, categoryId: 6, name: 'Aliança Navegação' },
    { _id: 178, categoryId: 5, name: 'Filmar pallet de 1 a 20' },
    { _id: 179, categoryId: 5, name: 'Filmar pallet de 21 a 40' },
    { _id: 180, categoryId: 5, name: 'Filmar pallet acima de 41' },
    { _id: 181, categoryId: 6, name: 'Filmar pallet de 1 a 20' },
    { _id: 182, categoryId: 6, name: 'Filmar pallet de 21 a 40' },
    { _id: 183, categoryId: 6, name: 'Filmar pallet acima de 41' },
    { _id: 184, categoryId: 5, name: 'Carreta' },
    { _id: 185, categoryId: 5, name: 'Pallet Desconto' },
    { _id: 186, categoryId: 6, name: 'Carreta' },
    { _id: 187, categoryId: 6, name: 'Pallet Desconto' },
    { _id: 188, categoryId: 5, name: 'Caminhão' },
    { _id: 189, categoryId: 6, name: 'Caminhão' },
    { _id: 190, categoryId: 5, name: 'Pallet' },
    { _id: 191, categoryId: 6, name: 'Pallet' },
    { _id: 192, categoryId: 5, name: 'Devolução Volume ou Pallet' },
    { _id: 193, categoryId: 6, name: 'Devolução Volume ou Pallet' },
    { _id: 194, categoryId: 6, name: 'Lonar e deslonar' },
    { _id: 195, categoryId: 1, name: 'Volume' },
    { _id: 196, categoryId: 5, name: 'Erro Logístico' },
    { _id: 197, categoryId: 5, name: 'Palete batido' },
    { _id: 198, categoryId: 5, name: 'Palete paletizado' },
    { _id: 199, categoryId: 4, name: 'Palete batido' },
    { _id: 200, categoryId: 4, name: 'Palete paletizado' },
    { _id: 201, categoryId: 5, name: 'Carreta Nestlé' },
    { _id: 202, categoryId: 6, name: 'Carreta Nestlé' },
    { _id: 203, categoryId: 5, name: 'Palete Camil' },
    { _id: 204, categoryId: 6, name: 'Palete Camil' },
    { _id: 205, categoryId: 1, name: 'Kia Bongo' },
    { _id: 206, categoryId: 9, name: 'Carros de móveis' },
    { _id: 207, categoryId: 9, name: 'Por colaborador' },
    { _id: 208, categoryId: 5, name: 'Palete Transp. SPAL' },
    { _id: 209, categoryId: 1, name: 'BAÚ' },
    { _id: 210, categoryId: 9, name: 'BAÚ' },
    { _id: 211, categoryId: 9, name: '01 até 04 volumes' },
    { _id: 212, categoryId: 9, name: '05 até 20 volumes (cada)' },
    { _id: 213, categoryId: 9, name: '21 até 50 volumes (cada)' },
    { _id: 214, categoryId: 9, name: 'Acima de 50 volumes (cada)' },
    { _id: 215, categoryId: 9, name: 'Pallets P1' },
    { _id: 216, categoryId: 9, name: 'Pallets P3' },
    { _id: 217, categoryId: 1, name: 'Pallets P1' },
    { _id: 218, categoryId: 1, name: 'Pallets P3' },
    { _id: 219, categoryId: 5, name: 'Baú 3 Corações' },
    { _id: 220, categoryId: 5, name: 'Carreta 3 Corações' },
    { _id: 221, categoryId: 5, name: 'Carreta Raça' },
    { _id: 222, categoryId: 5, name: 'Baú Raça' },
    { _id: 223, categoryId: 5, name: 'Van Raça' },
    { _id: 224, categoryId: 5, name: 'Container Transpesado' },
    { _id: 225, categoryId: 5, name: 'Container Palletizado Transarnold' },
    { _id: 226, categoryId: 5, name: 'Baú Tranzilli Nestlé' },
    { _id: 227, categoryId: 5, name: 'Palete puxado (seco) - Unid' },
    { _id: 228, categoryId: 5, name: 'Palete puxado (frigorifico) - Unid' },
    { _id: 229, categoryId: 5, name: 'Palete puxado (hortifruti) - Unid' },
    { _id: 230, categoryId: 5, name: 'Paletização/Repaletização com filme (seco) - Unid' },
    { _id: 231, categoryId: 5, name: 'Paletização/Repaletização com filme (frigorifico) - Unid' },
    { _id: 232, categoryId: 5, name: 'Paletização/Repaletização com filme (hortifruti) - Unid' },
    { _id: 233, categoryId: 5, name: 'Volume (seco)' },
    { _id: 234, categoryId: 5, name: 'Volume (hortifruti)' },
    { _id: 235, categoryId: 6, name: 'Palete puxado (seco) - Unid' },
    { _id: 236, categoryId: 6, name: 'Palete puxado (frigorifico) - Unid' },
    { _id: 237, categoryId: 6, name: 'Palete puxado (hortifruti) - Unid' },
    { _id: 238, categoryId: 6, name: 'Paletização/Repaletização com filme (seco) - Unid' },
    { _id: 239, categoryId: 6, name: 'Paletização/Repaletização com filme (frigorifico) - Unid' },
    { _id: 240, categoryId: 6, name: 'Paletização/Repaletização com filme (hortifruti) - Unid' },
    { _id: 241, categoryId: 6, name: 'Volume (seco)' },
    { _id: 242, categoryId: 6, name: 'Volume (hortifruti)' },
    { _id: 243, categoryId: 10, name: 'Palete puxado (seco) - Unid' },
    { _id: 244, categoryId: 10, name: 'Palete puxado (frigorifico) - Unid' },
    { _id: 245, categoryId: 10, name: 'Palete puxado (hortifruti) - Unid' },
    { _id: 246, categoryId: 10, name: 'Paletização/Repaletização com filme (seco) - Unid' },
    { _id: 247, categoryId: 10, name: 'Paletização/Repaletização com filme (frigorifico) - Unid' },
    { _id: 248, categoryId: 10, name: 'Paletização/Repaletização com filme (hortifruti) - Unid' },
    { _id: 249, categoryId: 10, name: 'Volume (seco)' },
    { _id: 250, categoryId: 10, name: 'Volume (hortifruti)' },
    { _id: 251, categoryId: 5, name: 'Manutenção pallete' },
    { _id: 252, categoryId: 5, name: 'Carro da casa' },
    { _id: 253, categoryId: 4, name: 'Manutenção pallete' },
    { _id: 254, categoryId: 4, name: 'Carro da casa' },
    { _id: 255, categoryId: 5, name: 'Leite Barra Mansa' },
    { _id: 256, categoryId: 4, name: 'Leite Barra Mansa' },
    { _id: 257, categoryId: 5, name: 'Mão de obra bobina' },
    { _id: 258, categoryId: 5, name: 'Palete batido 2024' },
    { _id: 259, categoryId: 5, name: 'Palete puxado 2024' },
    { _id: 260, categoryId: 5, name: 'Filme por pallet 2024' },
    { _id: 261, categoryId: 5, name: '0 a 15 volumes 2024' },
    { _id: 262, categoryId: 5, name: '16 a 30 volumes 2024' },
    { _id: 263, categoryId: 5, name: 'Remontagem de palete 2024' },
    { _id: 264, categoryId: 5, name: 'Coca Cola 2024' },
    { _id: 265, categoryId: 5, name: 'Ambev 2024' },
    { _id: 266, categoryId: 5, name: 'Leite Barra Mansa 2024' }
  ],
  orderStatuses: [
    { _id: '1', name: 'Aguardando pagamento' },
    { _id: '2', name: 'Pago' },
    { _id: '3', name: 'Cancelado' },
    { _id: '4', name: 'Isento' },
    { _id: '5', name: 'Inbound' },
    { _id: '6', name: 'Vencido' }
  ]
}

const getters = {
  getCountries: state => state.countries,
  getStates: state => state.states,
  getSchooling: state => state.schooling,
  getSchoolingStatuses: state => state.schoolingStatuses,
  getRoles: state => state.roles,
  getRoleName: state => id => state.roles.find(role => role._id == id).name,
  getManpowers: state => state.manpowers,
  getHiringStatuses: state => state.hiringStatuses,
  getExperienceDays: state => state.experienceDays,
  getWarningTypes: state => state.warningTypes,
  getPointActivities: state => state.pointActivities,
  getServiceCategories: state => state.serviceCategories,
  getServices: state => state.services,
  getOrderStatuses: state => state.orderStatuses
}

const mutations = {}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Form.js